import { useState } from "react";
import { Plus, BarChart3, Plane, Hotel, UtensilsCrossed, Bus, Ticket, ShoppingBag } from "lucide-react";
import MspShell from "../../components/msp/MspShell";

const TABS = ["All", "This Trip", "By Category"];
const ITEMS = [
  { id: "flights",  label: "Flights",         amount: 980, Icon: Plane,           hue: "bg-blue-50 text-blue-600" },
  { id: "hotels",   label: "Hotels",          amount: 840, Icon: Hotel,           hue: "bg-fuchsia-50 text-fuchsia-600" },
  { id: "dining",   label: "Dining",          amount: 320, Icon: UtensilsCrossed, hue: "bg-rose-50 text-rose-600" },
  { id: "trans",    label: "Transportation",  amount: 180, Icon: Bus,             hue: "bg-emerald-50 text-emerald-600" },
  { id: "acts",     label: "Activities",      amount: 110, Icon: Ticket,          hue: "bg-amber-50 text-amber-600" },
  { id: "shop",     label: "Shopping",        amount:  20, Icon: ShoppingBag,     hue: "bg-violet-50 text-violet-600" },
];

export default function MspExpenses() {
  const [t, setT] = useState("This Trip");
  const total = ITEMS.reduce((s, i) => s + i.amount, 0);
  return (
    <MspShell title="Expenses" testid="msp-expenses">
      <div className="grid grid-cols-3 rounded-2xl bg-white border border-slate-200 p-1" data-testid="msp-exp-tabs">
        {TABS.map((x) => (
          <button key={x} onClick={() => setT(x)} data-testid={`msp-exp-tab-${x.toLowerCase().replace(/\s+/g,"-")}`}
            className={`py-2.5 rounded-xl text-sm font-700 transition ${t === x ? "bg-blue-600 text-white shadow" : "text-slate-500 hover:text-slate-800"}`}>
            {x}
          </button>
        ))}
      </div>

      <div className="bg-white rounded-3xl border border-slate-200 p-5 shadow-sm">
        <div className="flex items-center justify-between">
          <div className="min-w-0">
            <div className="text-xs text-slate-500 font-mono uppercase tracking-widest">Japan Cherry Blossom · Mar 27 – Apr 5, 2027</div>
            <div className="font-serif font-800 text-sm text-slate-500 mt-3">Total Expenses</div>
            <div className="font-serif font-800 text-4xl text-blue-900 tracking-tight mt-0.5">${total.toLocaleString()}</div>
          </div>
          <div className="w-16 h-16 rounded-2xl bg-blue-50 text-blue-600 grid place-items-center">
            <BarChart3 className="w-7 h-7" />
          </div>
        </div>
      </div>

      <div className="space-y-2.5">
        {ITEMS.length === 0 ? (
          <div className="rounded-3xl border-2 border-dashed border-slate-300 bg-white p-8 text-center" data-testid="msp-exp-empty">
            <div className="w-14 h-14 mx-auto rounded-full bg-amber-50 grid place-items-center mb-3">
              <BarChart3 className="w-6 h-6 text-amber-600" />
            </div>
            <div className="font-serif font-800 text-lg text-blue-900">No expenses yet</div>
            <p className="text-sm text-slate-500 mt-1 max-w-xs mx-auto">Snap a receipt or add a manual entry — we'll auto-categorise and split it by trip.</p>
            <button data-testid="msp-exp-empty-cta"
              className="mt-4 inline-flex items-center gap-1.5 bg-amber-600 text-white font-800 text-sm px-5 py-2.5 rounded-full hover:bg-amber-700">
              <Plus className="w-4 h-4" /> Add first expense
            </button>
          </div>
        ) : ITEMS.map(({ id, label, amount, Icon, hue }) => (
          <div key={id} data-testid={`msp-exp-${id}`}
            className="flex items-center gap-3 bg-white rounded-2xl border border-slate-200 p-3.5">
            <span className={`w-10 h-10 rounded-xl grid place-items-center ${hue}`}><Icon className="w-5 h-5" /></span>
            <div className="flex-1 font-700 text-slate-900">{label}</div>
            <div className="text-slate-900 font-700">${amount}</div>
          </div>
        ))}
      </div>

      <button data-testid="msp-exp-add"
        className="w-full inline-flex items-center justify-center gap-2 rounded-2xl bg-blue-600 text-white py-3.5 font-700 hover:brightness-110">
        <Plus className="w-4 h-4" /> Add Expense
      </button>
    </MspShell>
  );
}
